import { Component, model, output } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { CheckboxModule } from 'primeng/checkbox';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { Button } from 'primeng/button';
import { ColorPickerModule } from 'primeng/colorpicker';

export type AddEditLabelDialogComponentModel = {
    labelName: string,
    colorCode: string
};

@Component({
    selector: 'mon-add-edit-label-dialog',
    imports: [
        TranslocoModule,
        CheckboxModule,
        InputTextModule,
        FormsModule,
        Button,
        ColorPickerModule,
    ],
    templateUrl: './add-edit-label-dialog.component.html',
    styleUrls: ['./add-edit-label-dialog.component.scss'],
})
export class AddEditLabelDialogComponent {
    formModel = model<AddEditLabelDialogComponentModel>({
        colorCode: '',
        labelName: '',
    });
    formSubmit = output<AddEditLabelDialogComponentModel | null>();

    cancel (): void {
        this.formSubmit.emit(null);
    }

    save (): void {
        this.formSubmit.emit(this.formModel());
    }
}
